import { render, staticRenderFns } from "./OtherUserSafetyConfirmAnswers.vue?vue&type=template&id=44c07a3f&scoped=true&lang=pug"
import script from "./OtherUserSafetyConfirmAnswers.vue?vue&type=script&lang=ts"
export * from "./OtherUserSafetyConfirmAnswers.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserSafetyConfirmAnswers.vue?vue&type=style&index=0&id=44c07a3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c07a3f",
  null
  
)

export default component.exports